import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * 先例・判例書籍取得API
 * @param  {} params={}
 */
export const getBook = (params = {}) => {
  const defaults = {
    _path: 'PJ/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}


/**
 * 先例・判例目次取得API
 * @param  {} params={}
 */
export const getTOC = (params = {}) => {
  const defaults = {
    _path: 'PJ/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}


/**
 * 先例・判例検索API
 * @param  {} params={}
 */
export const search = (params = {}) => {
  const defaults = {
    _path: 'PJ/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}


/**
 * 先例・判例詳細API
 * @param  {} params={}
 */
export const detail = (params = {}) => {
  const defaults = {
    _path: 'PJ/004',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}


/**
 * 先例・判例検索数API
 * @param  {} params={}
 */
export const searchCount = (params = {}) => {
  const defaults = {
    _path: 'PJ/005',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
